import { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Transition } from "@headlessui/react";
import Image from "./common/Image";
import Button from "./common/Button";
import Heading from "./common/Heading";
import Teaser from "./Teaser";

import getBaseUri from "../utilities/getBaseUri";

import checkStateDate from "../utilities/checkStateDate";

import { Swiper, SwiperSlide } from "swiper/react";

import SliderItem from "./SliderItem";
import ModalFull from "./ModalFull";
//import ModalExtra from "./ModalExtra";
import FlexList from "./FlexList";
import CheckList from "./CheckList";
import Contact from "./Contact";
import OverviewIcons from "./OverviewIcons";

import { useTabStore } from "../store/tab-store";

// import iconMapping from "../icon-mapping.json";

import { LangContext } from "../context/lang-context";
import OpeningTimesTable from "./OpeningTimesTable";
import SimpleText from "./SimpleText";

function TabOverview(props) {
  const { t, i18n } = useTranslation();

  const { lang } = useContext(LangContext);

  const langFull = {de: "german", en: "english", fr: "french", it: 'italian'};

  const [hoursModalOpen, setHoursModalOpen] = useState(false);
  const closeHoursModal = () => {
    setHoursModalOpen(false);
  };

  const [flatrateModalOpen, setFlatrateModalOpen] = useState(false);
  const closeFlatrateModal = () => {
    setFlatrateModalOpen(false);
  };


  let options = props.options? JSON.parse(props.options) : false;
  const isLivegroupfitness = props.isLivegroupfitness !== 0 && props.isLivegroupfitness !== "0" ? true: false;

  const benefit_items = props.data?.optionalData?.whatweoffer ?
  props.data.optionalData.whatweoffer
    .filter(benefit => isLivegroupfitness || !benefit.text.has_livegroupfitness)  // Filtert basierend auf isLivegroupfitness
    .map(benefit => benefit.text[lang])  // Extrahiert text[lang] von den gefilterten Elementen
  : false;
  
  
  
  let refTimer;
  let slides =
    props.data.images && props.data.images.length > 0
      ? props.data.images.map(
          (item) => item
        )
      : [
          `${process.env.PUBLIC_URL}/images/fallback_club_01.jpg`,
          `${process.env.PUBLIC_URL}/images/fallback_club_02.jpg`,
          `${process.env.PUBLIC_URL}/images/fallback_club_03.jpg`,
        ];

  if(typeof options.studio_images !== 'undefined' && options.studio_images && options.studio_images.length > 0 ) slides = options.studio_images;
  if(props.yt)
  slides.unshift({video: props.yt});

  const slidesTitle =
     props.data.images && props.data.images.length > 0 ? (
      <>
        {t("overview.look_into_club")}
      </>
    ) : (
      t("overview.typical_club")
    );

  useEffect(() => {
    return () => {
      clearTimeout(refTimer);
    };
  }, [refTimer]);

  const [tab, setTab] = useTabStore((state) => [state.tab, state.setTab]);
  let yearlyOnMonth = 12;
  
  let corePrices = [];
  if (!!props.prices.core)
    corePrices.push({
      value: "CHF " + props.prices.core,
      label: t("overview.monthly"),
    });

  if (!!props.prices.core12)
    corePrices.push({
      value: "CHF " + Math.trunc(props.prices.core12),
      label: t("overview.yearly")
    });
  
  if(yearlyOnMonth !== false){
    corePrices = [];
    corePrices.push({
      prepend: t("cta.from"),
      value: "CHF " + Math.trunc(props.prices.core12/yearlyOnMonth),
      label: t("overview.monthly"),
    });
  }

  let premiumPrices = [];
  if (!!props.prices.premium)
    premiumPrices.push({
      value: "CHF " + Math.trunc(props.prices.premium),
      label: t("overview.monthly")
    });

  if (!!props.prices.premium12)
    premiumPrices.push({
      value: "CHF " + Math.trunc(props.prices.premium12),
      label: t("overview.yearly"),
    });

  if(yearlyOnMonth !== false){
    premiumPrices = [];
    premiumPrices.push({
      prepend: t("cta.from"),
      value: "CHF " + Math.trunc(props.prices.premium12/yearlyOnMonth),
      label: t("overview.monthly")
    });
  }  

  let unlimitedPrices = [];
  if (!!props.prices.unlimited)
    unlimitedPrices.push({
      value: "CHF " + Math.trunc(props.prices.unlimited),
      label: t("overview.monthly")
    });

  
  if (!!props.prices.unlimited12)
    unlimitedPrices.push({
      value: "CHF " + Math.trunc(props.prices.unlimited12),
      label: t("overview.yearly")
    });
  

  let offers = Object.entries(props.data.bestOffer).reduce(
    (filtered, [name, offer]) => {
      if (typeof offer === "object" && offer !== null) {
        offer.type = name;
        filtered.push(offer);
      }
      return filtered;
    },
    []
  );

  const features = props.data.optionalData?.features
    ? props.data.optionalData?.features.reduce((reduced, feature) => {
        if (feature.active) {
          if (feature.icon) feature.icon = feature.icon.replace(/^ch-/, "");
          else feature.icon = "inklusive";
          reduced.push(feature);
        }
        return reduced;
      }, [])
    : [];
    
  let flatrates = Object.entries(props.data.bestOffer).reduce(
    (filtered, [name, offer]) => {
      if (typeof offer === "object" && offer !== null) {
        offer.special = name === "Sparpaket" ? true : false;
        filtered.push(offer);
      }

      return filtered;
    },
    []
  );
    
  let subscriptionBoxes = Object.entries(props.data.subscriptionBoxes).reduce(
    (filtered, [name, subBox]) => {
      if (typeof subBox === "object" && subBox !== null) {
        filtered[subBox.title] = subBox;
      }

      return filtered;
    },
    []
  );

  const premiumInfo = subscriptionBoxes?.Premium ? subscriptionBoxes.Premium : null;
  const coreInfo = subscriptionBoxes?.Core ? subscriptionBoxes.Core : null;

  const unlimitedInfo = props.data.optionalData?.memberShipInfos?.find(
    (info) => info.type === "unlimited"
  );
  const memberShipInfos = {
    premium: {
      img: (subscriptionBoxes?.Premium?.image) ? getBaseUri()+ subscriptionBoxes.Premium.image :`${process.env.PUBLIC_URL}/images/fallback_premium.jpg`,
      title: premiumInfo
        ? premiumInfo[lang].title
        : t("overview.premium_title"),
      text: premiumInfo ? premiumInfo[lang].text : t("overview.premium_text"),
    },
    core: {
      img: (subscriptionBoxes?.Core?.image) ? getBaseUri()+ subscriptionBoxes.Core.image :`${process.env.PUBLIC_URL}/images/fallback_core.jpg`,
      title: coreInfo ? coreInfo[lang].title : t("overview.core_title"),
      text: coreInfo ? coreInfo[lang].text : t("overview.core_text"),
    },
    unlimited: {
      img: `${process.env.PUBLIC_URL}/images/fallback_unlimited.jpg`,
      title: unlimitedInfo
        ? unlimitedInfo.title[lang]
        : t("overview.unlimited_title"),
      text: unlimitedInfo
        ? unlimitedInfo.text[lang]
        : t("overview.unlimited_text"),
    },
  };

  /* ”qualitop”, ”aktion”, “livegroupfitness”, “probetraining” */

  let boxContainer = {};
  let tempBoxContainer =
    props.data.optionalData?.boxes ??
    Object.assign({}, props.data.optionalData.boxes);

  for (let item in tempBoxContainer) {
    const type = tempBoxContainer[item].type;
    boxContainer[type] = tempBoxContainer[item][lang];
    let img_suffix = (lang !=='de' && tempBoxContainer[item]['image_'+lang]) ? 'image_'+lang  : 'image';
    boxContainer[type]['img'] = getBaseUri()+tempBoxContainer[item][img_suffix];
  }
  
  const upgradeName = 'zzz',
        isUpgrade = boxContainer[upgradeName]? boxContainer[upgradeName] : false;
  let upgrade = false;
  
  if(isUpgrade){
    upgrade = {
      title:
        isUpgrade?.title[lang] ??
        t("overview.upgrade_teaser_title"),
      text:
        isUpgrade?.text[lang] ??
        t("overview.upgrade_text"),
      img:
        isUpgrade?.img ??
        `${process.env.PUBLIC_URL}/images/fallback_upgrade.jpeg`,
    }
  }
  
  let extrabox = options?.planned_boxes?.extrabox?.title && options?.planned_boxes?.extrabox?.img ? {
    title:
      options?.planned_boxes?.extrabox?.title.replace('{{club}}',props.data.name) ??
      t("overview.offers_in_club_title", {
        club: props.data.name,
      }),
    text:
      options?.planned_boxes?.extrabox?.text.replace('{{club}}',props.data.name) ??
      t("overview.offers_in_club_text", {
        club: props.data.name,
      }),
    img:
      options?.planned_boxes?.extrabox?.img ??
      `${process.env.PUBLIC_URL}/images/fallback_angebot.jpg`,
  } : false;
  
  
  let boxes = {
    aktion: {
      title:
        boxContainer?.aktion?.title.replace('{{club}}',props.data.name) ??
        t("overview.offers_in_club_title", {
          club: props.data.name,
        }),
      text:
        boxContainer?.aktion?.text.replace('{{club}}',props.data.name) ??
        t("overview.offers_in_club_text", {
          club: props.data.name,
        }),
      img:
        boxContainer?.aktion?.img ??
        `${process.env.PUBLIC_URL}/images/fallback_angebot.jpg`,
    },
    livegroupfitness: {
      title:
        boxContainer?.livegroupfitness?.title ??
        t("overview.lgf_teaser_title"),
      text:
        boxContainer?.livegroupfitness?.text ??
        t("overview.lgf_teaser_text"),
      img:
        boxContainer?.livegroupfitness?.img ??
        `${process.env.PUBLIC_URL}/images/fallback_lgf.jpg`,
    },
    probetraining: {
      title:
        boxContainer?.probetraining?.title ??
        t("overview.training_title"),
      text:
        boxContainer?.probetraining?.text ?? t("overview.training_text"),
      img:
        boxContainer?.probetraining?.img ??
        `${process.env.PUBLIC_URL}/images/fallback_probetraining.jpg`,
    },
    qualitop: {
      title:
        boxContainer?.qualitop?.title ??
        t("overview.qualitop_title"),
      text:
        boxContainer?.qualitop?.text ?? t("overview.qualitop_text"),
      img:
        boxContainer?.qualitop?.img ??
        `${process.env.PUBLIC_URL}/images/fallback_qualitop.jpg`,
    },
  };
  
  if(options.box_images && options.box_images.length >0){
    options.box_images.forEach(box => {
      if(boxes.hasOwnProperty(box.location)){
        boxes[box.location].img = box.image.url;
      }
    });
  }
  const otherBoxes =
    props.data.optionalData?.boxes?.reduce((reduced, box, index) => {
      if (!["aktion", "livegroupfitness", "probetraining", "qualitop", upgradeName].includes(box.type)) {
        reduced.push({
          title: box.title[lang],
          text: box.text[lang],
          img: box.img,
        });
      }
      return reduced;
    }, []) ?? [];

  // ------------------------------------------------------------------------------------------

  const isPresale =
    checkStateDate(props.data.status.isPresale) &&
    !checkStateDate(props.data.status.isComingSoon);
  const isNotPresale = !checkStateDate(props.data.status.isPresale);
  const isComingSoon =
    checkStateDate(props.data.status.isComingSoon) &&
    !!checkStateDate(props.data.status.isPresale);
  const is247 = props.data.optionalData.openingTimes.is24_7;
  //const not247 = !props.data.optionalData.isOpen247;
  // if default or isComingSoon
  const showImgText = (isUpgrade || isPresale || isComingSoon) ? true : false;

  let outsideModal = (
    <OpeningTimesTable
      times={props.data.optionalData?.openingTimes?.zeiten_de ?? null}
    />
  );
  let insideModal = props.data.optionalData?.deviationTimes?.zeiten_de ? (
    <OpeningTimesTable times={props.data.optionalData?.deviationTimes?.zeiten_de} />
  ) : null;
  let headline =
    props.data.optionalData?.openingTimes?.title[lang] ?? t("overview.hours");
  if(is247) headline = t("overview.hours");
  let buttonTitle =
    props.data.optionalData?.openingTimes?.buttonTitle && props.data.optionalData?.openingTimes?.buttonTitle[lang] ? props.data.optionalData?.openingTimes?.buttonTitle[lang] :
    t("overview.deviating_hours");
  let modalTitle =
    props.data.optionalData?.deviationTimes?.title[lang] ??
    t("overview.deviating_hours");
  let modalSubtitle =
    props.data.optionalData?.deviationTimes?.subtitle[lang] ?? null;

  if (isPresale && props.data.optionalData.presaleTimes) {
    headline =
      props.data.optionalData.presaleTimes?.title[lang] ??
      t("overview.presale");
    buttonTitle = props.data.optionalData.presaleTimes?.buttonTitle[lang] ?? "";
    outsideModal = (
      <OpeningTimesTable times={props.data.optionalData.presaleTimes.zeiten_de} />
    );
    if (props.data.optionalData.openingTimes) {
      modalTitle = props.data.optionalData.openingTimes.title[lang];
      modalSubtitle = props.data.optionalData.openingTimes.subtitle[lang];
      insideModal = is247 ? (
        <div className="tw-px-5">{t("overview.open_24_7")}</div>
      ) : (
        <OpeningTimesTable times={props.data.optionalData.openingTimes.zeiten_de} />
      );
    }
  } else if (isNotPresale && props.data.optionalData?.openingTimes) {
    // if (isComingSoon) {
    //   headline =
    //     props.data.optionalData?.openingTimes?.title[lang] ??
    //     t("overview.hours_from_date", {
    //       date:
    //         new Date(props.data.status.isComingSoon) ??
    //         t("overview.opening_date"),
    //     });
    // }
    if (is247) {
      outsideModal = <div className="tw-px-5">{t("overview.open_24_7")}</div>;
      if (props.data.optionalData.unattendedTimes?.buttonTitle[lang]) {
        // headline =
        //   props.data.optionalData.unattendedTimes.title[lang] ??
        //   t("overview.unsupervised_hours");
        modalTitle = props.data.optionalData.unattendedTimes.title[lang];
        modalSubtitle = props.data.optionalData.unattendedTimes.subtitle[lang];
        buttonTitle = props.data.optionalData.unattendedTimes.buttonTitle[lang];
        insideModal = (
          <OpeningTimesTable
            times={props.data.optionalData.unattendedTimes.zeiten_de}
          />
        );
      }
    }
  }
  
  if(options.extra_times_button && options.extra_times_button.hasOwnProperty(lang) && options.extra_times_button[lang] !== ''){
    let buttonString =  options.extra_times_button[lang];
    buttonTitle = (typeof buttonString === "string" && buttonString.trim().length === 0 && buttonString) ? buttonTitle: buttonString ;
  }

  let extraTimesTable = false;
  if(options.opening_times && options.opening_times.hasOwnProperty('button') && options.opening_times['button'] !== ''){
    let buttonString =  options.opening_times['button'];
    buttonTitle = (typeof buttonString === "string" && buttonString.trim().length === 0 && buttonString) ? buttonTitle: buttonString ;
    
  }
  let extraTimesTitle = false;
  if(options.opening_times && options.opening_times.hasOwnProperty('title')){
     extraTimesTitle = options.opening_times?.title ? <div className="tw-font-condensed tw-font-black tw-text-xl lg:tw-text-xl tw-uppercase tw-italic tw-leading-3 tw-p-5 tw-pt-8">{options.opening_times.title}</div> : false;
    
  }

  if(options.opening_times && options.opening_times.hasOwnProperty('times')){
    extraTimesTable = <><OpeningTimesTable times={options.opening_times?.times} /></>
    
  }

  for(let item in boxes){
    if(options.planned_boxes && options.planned_boxes[item]){
      boxes[item] =  options.planned_boxes[item];
    }
  }

  // Funktion zum Entfernen von Boxen ohne Titel oder Text
  const cleanBoxes = (boxes) => {
    for (let key in boxes) {
      if (!boxes[key].title || !boxes[key].text) {
        delete boxes[key];
      }
    }
  };

  cleanBoxes(boxes);
  //console.log(props.data.text,'texts');
  const membership_and_prices_title = props.data.text?.membership[lang]?.title && props.data.text?.membership[lang]?.title != '' ? props.data.text.membership[lang].title.replace(/{club}/g, props.data.name): t("overview.membership_and_prices_title");
  const membership_and_prices_text = props.data.text?.membership[lang]?.text && props.data.text?.membership[lang]?.text != '' ? props.data.text.membership[lang].text.replace(/{club}/g, props.data.name): false;
  
  const studio_images_title = props.data.text?.club[lang]?.title && props.data.text?.club[lang]?.title != '' ? props.data.text.club[lang].title.replace(/{club}/g, props.data.name): slidesTitle;
  const studio_images_text = props.data.text?.club[lang]?.text && props.data.text?.club[lang]?.text != '' ? props.data.text.club[lang].text.replace(/{club}/g, props.data.name): false;
  
  const studio_overview_title = props.data.text?.overview[lang]?.title && props.data.text?.overview[lang]?.title != '' ? props.data.text.overview[lang].title.replace(/{club}/g, props.data.name): '';
  const studio_overview_subtitle = props.data.text?.overview[lang]?.subtitle && props.data.text?.overview[lang]?.subtitle != '' ? props.data.text.overview[lang].subtitle.replace(/{club}/g, props.data.name): '';
  const studio_overview_text = props.data.text?.overview[lang]?.text && props.data.text?.overview[lang]?.text != '' ? props.data.text.overview[lang].text.replace(/{club}/g, props.data.name): false;
  
  const studio_offers_title = props.data.text?.offers[lang]?.title && props.data.text?.offers[lang]?.title != '' ? props.data.text.offers[lang].title.replace(/{club}/g, props.data.name): '';
  const studio_offers_subtitle = props.data.text?.offers[lang]?.subtitle && props.data.text?.offers[lang]?.subtitle != '' ? props.data.text.offers[lang].subtitle.replace(/{club}/g, props.data.name): '';
  
  const studio_features_title = props.data.text?.features[lang]?.title && props.data.text?.features[lang]?.title != '' ? props.data.text.features[lang].title.replace(/{club}/g, props.data.name): '';
  const studio_features_text = props.data.text?.features[lang]?.text && props.data.text?.features[lang]?.text != '' ? props.data.text.features[lang].text.replace(/{club}/g, props.data.name): false;
  
  const studio_lgf_title = props.data.text?.lgf[lang]?.title && props.data.text?.lgf[lang]?.title != '' ? props.data.text.lgf[lang].title.replace(/{club}/g, props.data.name): t("overview.lgf_title");
  const studio_lgf_subtitle = props.data.text?.lgf[lang]?.text && props.data.text?.lgf[lang]?.text != '' ? props.data.text.lgf[lang].text.replace(/{club}/g, props.data.name): t("overview.lgf_subtitle");
  
  const overviewIcons = (<OverviewIcons
    expect_in_club={t("overview.expect_in_club")}
    headline={headline}
    outsideModal={outsideModal}
    extraTimesTitle={extraTimesTitle}
    extraTimesTable={extraTimesTable}
    insideModal={insideModal}
    buttonTitle={buttonTitle}
    setHoursModalOpen={() => {setHoursModalOpen(true)}}
    hoursModalOpen={hoursModalOpen}
    closeHoursModal={() => {closeHoursModal()}}
    modalTitle={modalTitle}
    modalSubtitle={modalSubtitle}
    features={features}
    lang={lang}
  />);

  const aktionTeaser = (<>
  <Heading
    title={t("overview.teaser_title")}
    subtitle={t("overview.teaser_subtitle")}
    className="tw-pt-12"
  />
  {boxes.aktion && (<Teaser
    image={upgrade ? upgrade.img: boxes.aktion.img}
    title={upgrade ? upgrade.title: boxes.aktion.title}
    text={upgrade ? upgrade.text: boxes.aktion.text}
    prices={props.prices}
    className="tw-mt-5 tw-mb-5"
  />)}</>);

  const switchPosition = props.data.reverse_top_boxes?? props.data.reverse_top_boxes;
  const memberLink = props.data.links.custom_link?.[lang] ? props.data.links.custom_link[lang] :  props.data.links.exerp+'/join/plan?center='+ props.shopId + '&lang='+langFull[lang];
  
  // ------------------------------------------------------------------------------------------
  if(Object.keys(props.prices).length !== 0)
  return (
    <>
      <Transition show={tab === "overview"} appear={true} unmount={false}>
        <div className="tw-m-auto tw-max-w-screen-lg">
          {switchPosition && (aktionTeaser)}
          {overviewIcons}
          {studio_overview_title !== false && studio_overview_title !== '' && 
          (<Heading
            title={studio_overview_title}
            subtitle={studio_overview_subtitle}
            className="tw-pt-12"
                    />)}
          {studio_overview_text !== false && studio_overview_text != '' && (<SimpleText text={studio_overview_text}/>)}
          {!switchPosition && (aktionTeaser)}

          {extrabox && <Teaser
                key={`other_box`}
                image={extrabox.img}
                title={extrabox.title}
                text={extrabox.text}
                className="tw-mt-5 tw-mb-12"
              />}
          <div className="tw-relative tw-pt-5 membership_and_prices">
            <div className="tw-absolute tw--top-12" id="options"></div>
            <Heading
              title={membership_and_prices_title}
              subtitle={t("overview.membership_and_prices_subtitle")}
              className="tw-mb-5"
            />
            {membership_and_prices_text !== false && (<SimpleText  text={membership_and_prices_text} />)}
          </div>
          { unlimitedPrices.length > 0 && <Teaser
            key={`other_box_x`}
            image={memberShipInfos.unlimited.img}
            title={memberShipInfos.unlimited.title}
            text={memberShipInfos.unlimited.text}
            className="tw-mt-8 tw-mb-6 unlimited membership_and_prices"
            pricing={{
              values: unlimitedPrices,
              caption:  props.prices.unlimitedStartup === 0 || props.prices.unlimitedStartup === '' ? t("overview.no_subscription_fee") : t("overview.subscription_fee"),
              startup: props.prices.unlimitedStartup
            }}
          />}
          <div className="md:tw-flex md:tw-space-x-5">
            <Teaser
              image={memberShipInfos.premium.img}
              title={memberShipInfos.premium.title}
              text={memberShipInfos.premium.text}
              color="gray-light"
              layout="horizontal"
              className="md:tw-flex-1 membership_and_prices"
               pricing={{
                 values: premiumPrices,
                 caption:  props.prices.premiumStartup === 0 || props.prices.premiumStartup === '' ? t("overview.no_subscription_fee") : t("overview.subscription_fee"),
                 startup: props.prices.premiumStartup
               }}
            />
            <Teaser
              image={memberShipInfos.core.img}
              title={memberShipInfos.core.title}
              text={memberShipInfos.core.text}
              layout="horizontal"
              className="md:tw-flex-1 membership_and_prices"
               pricing={{
                 values: corePrices,
                 caption:  props.prices.coreStartup === 0 || props.prices.coreStartup === '' ? t("overview.no_subscription_fee") : t("overview.subscription_fee"),
                 startup: props.prices.coreStartup
               }}
            />
          </div>

          <div className="tw-px-5 tw-pt-12 tw-pb-3 lg:tw-mt-12 lg:tw-px-0">
            <div className="tw-font-condensed tw-font-black tw-text-xl lg:tw-text-3xl tw-uppercase tw-italic tw-leading-6 md:tw-leading-5">
              {studio_images_title}
            </div>
          </div>
            {studio_images_text !== false && (<SimpleText text={studio_images_text}/>)}
          <Swiper
            slidesPerView={"auto"}
            initialSlide={0}
            spaceBetween={8}
            // centeredSlides={true}
            // centeredSlidesBounds={true}
            className="tw-pt-5 tw-px-5 lg:tw-px-0"
          >
            {slides.map((slide, index) => {
              const slideProps = {
                image: getBaseUri()+slide,
                video: slide.video
              };
              return (
                <SwiperSlide
                  className={`tw-w-auto tw-max-w-xs lg:tw-max-w-sm`}
                  key={"slider_item_" + index}
                >
                  <SliderItem className="tw-h-48" {...slideProps} isPresale={showImgText} presaleText={t("overview.presale_img_text")}/>
                </SwiperSlide>
              );
            })}
          </Swiper>
          {props.clubtour && (
            <div className="tw-pb-12 tw-pt-3 tw-text-center lg:tw-mb-5">
              <Button
                title={t("overview.look_into_club")}
                color="black"
                type="outline"
                size="medium"
                className="tw-mt-2"
                href={props.clubtour}
                target="_blank"
              />
            </div>
          )}
          <div className="tw-p-5 tw-pt-8 tw-pb-12 tw-bg-gray-light lg:tw-p-0 lg:tw-bg-white lg:tw-mt-12 our_extras">
            <div className="tw-font-condensed tw-font-black tw-text-xl lg:tw-text-3xl tw-uppercase tw-italic tw-leading-5">
              { studio_features_title ? studio_features_title : t("overview.flatrates")}
            </div>
              { studio_features_text !== false && (<SimpleText classNames="!tw-mt-2" text={studio_features_text}/>)}
            <FlexList
              size="large"
              gap="default"
              className="tw-mt-3"
              items={offers}
              which="flats"
            />
            <div className="md:tw-flex md:tw-items-center">
              <Button
                size="large"
                color="teal"
                type="fill"
                title={t("overview.read_more")}
                className="tw-mt-10 tw-w-full md:tw-w-auto md:tw-mx-auto"
                onClick={() => {
                  setFlatrateModalOpen(true);
                }}
              />
            </div>
            <ModalFull
              isOpen={flatrateModalOpen}
              closeModal={closeFlatrateModal}
              title={t("overview.choose_flatrate")}
              scrollable={true}
            >
              <div className="tw-pb-12">
                {flatrates.map((item, index) => {
                  const buttonOptions = item.special
                    ? {
                        type: "fill",
                        size: "medium",
                        color: "orange",
                        className: "tw-w-full",
                      }
                    : {
                        type: "text",
                        size: "small",
                        color: "orange",
                      };
                  buttonOptions.className += " md:tw-w-auto";

                  let imageUrl = `${process.env.PUBLIC_URL}/images/`;
                  
                  switch (item.title) {
                    case "Solarium":
                      imageUrl += "fallback_flatrate_solarium.jpg";
                      if(item.image) imageUrl = getBaseUri()+item.image;
                      break;
                    case "Power Plate":
                      imageUrl += "fallback_flatrate_powerplate.jpg";
                      if(item.image) imageUrl = getBaseUri()+item.image;
                      break;
                    case "Getränke":
                      imageUrl += "fallback_flatrate_getraenke.jpg";
                      if(item.image) imageUrl = getBaseUri()+item.image;
                      break;
                    case "Nutrition":
                      imageUrl += "fallback_flatrate_nutrition.jpg";
                      if(item.image) imageUrl = getBaseUri()+item.image;
                      break;
                    case "Bodi":
                      imageUrl += "fallback_boditrax.jpg";
                      if(item.image) imageUrl = getBaseUri()+item.image;
                      break;
                    case "ALL IN ONE":
                      imageUrl += "fallback_flatrate_aio.jpg";
                      if(item.image) imageUrl = getBaseUri()+item.image;
                      break;
                    default:
                      imageUrl = item.image? getBaseUri()+item.image : `${process.env.PUBLIC_URL}/images/`+"fallback_angebot.jpg";
                      break;
                  }

                  return (
                    <div className="tw-p-5" key={"flatrate_" + index}>
                      <Image
                        className="tw-rounded-2xl tw-mb-4 tw-w-full"
                        src={imageUrl}
                      />
                      <div className="tw-flex tw-justify-between tw-space-x-5">
                        <div className="tw-font-condensed tw-font-black tw-text-xl tw-uppercase tw-italic tw-leading-5">
                          {item.title}
                        </div>
                        {item.value != '0' && (<div className="tw-font-condensed tw-font-black tw-text-xl tw-uppercase tw-italic tw-leading-5">
                          CHF {item.value}
                        </div>)}
                      </div>
                      <div className="tw-mt-1 tw-text-sm">{item.subtext}</div>
                      <div className="tw-mt-5">{item.text}</div>
                      <div className="tw-mt-5 tw-text-center">
                        <Button
                          href={ memberLink }
                          title={t("overview.select_flatrate")}
                          {...buttonOptions}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </ModalFull>
          </div>
            {isLivegroupfitness && (<>
              <Heading
                title={studio_lgf_title}
                subtitle={studio_lgf_subtitle}
                className="tw-mt-12 lg:tw-mt-24"
              />
              <Teaser
                image={boxes.livegroupfitness.img}
                title={boxes.livegroupfitness.title}
                text={boxes.livegroupfitness.text}
                buttons={[
                  {
                    title: t("overview.show_courses"),
                    color: "teal",
                    size: "large",
                    type: "fill",
                    onClick: () => window.location.href = props.data.links.exerp+'/booking?centers='+props.shopId+'&lang='+langFull[lang],
                  },
                  // {
                  //   href: "#",
                  //   title: "Button 2",
                  //   color: "black",
                  //   size: "medium",
                  //   type: "outline",
                  // },
                ]}
              />
            </>)}

          <Heading
            title={(studio_offers_title) ? studio_offers_title: t("overview.benefits_title")}
            subtitle={(studio_offers_subtitle) ? studio_offers_subtitle: t("overview.benefits_subtitle")}
            className="tw-mt-12 tw-mb-8 lg:tw-mt-24"
          />
          <CheckList
            title={t("overview.benefits_list_title")}
            items={benefit_items ? benefit_items : t("overview.benefits_list_items").split("\n")}
          />
          { boxes.qualitop && (<Teaser
            image={boxes.qualitop.img}
            title={boxes.qualitop.title}
            text={boxes.qualitop.text}
            className="tw-mt-5 tw-mb-5"
            index="1"
            buttons={[
              {
                title: t("overview.qualitop_button"),
                color: "teal",
                size: "large",
                type: "fill",
                href: t("links.qualitop"),
              },
            ]
            }
          />)}

          {boxes.probetraining && (<Teaser
            image={boxes.probetraining.img}
            title={boxes.probetraining.title}
            text={boxes.probetraining.text}
            className="tw-mt-5 tw-mb-12 probetraining"
            buttons={
              isComingSoon || isPresale
                ? []
                : // : !props.isLivegroupfitness
                  // ? [
                  //     {
                  //       title: t("overview.start_training"),
                  //       color: "teal",
                  //       size: "large",
                  //       type: "fill",
                  //       href: t("links.free_trial"),
                  //     },
                  //   ]
                  [
                    {
                      title: t("overview.start_training"),
                      color: "teal",
                      size: "large",
                      type: "fill",
                      href: props.data.links.exerp+"/join/details?center="+ props.shopId+"&plan=ONE_DAY_PASS&promoCode=DAYPASS&lang="+langFull[lang],
                    },
                  ]
            }
          />)}
          {otherBoxes &&
            otherBoxes.map((box, index) => (
              <Teaser
                key={`other_box_${index}`}
                image={box.img}
                title={box.title}
                text={box.text}
                className="tw-mt-5 tw-mb-12"
              />
            ))}

          <Heading
            title={t("overview.contact_title")}
            subtitle={t("overview.contact_subtitle")}
            className="tw-mt-12 tw-mb-8 lg:tw-mt-24"
          />
          <Contact data={props.data} bgmap={props.bgmap} />
        </div>
      </Transition>
    </>
  );
}

export default TabOverview;
